import { createStore } from 'satcheljs';
import { IPublisherViewState } from './schema/IPublisherViewState';

export const getStore = createStore<IPublisherViewState>('PublisherState', {
  active: {},
  errors: {}
});
